module.exports = __webpack_public_path__ + "static/media/fingerprint.b26973f6.svg";